import { useTranslation } from 'next-i18next'

import { ProgressBar } from '~/components'
import { useAppSelector } from '~/redux/hooks'

import { selectBossHealth, selectHasStartedQuiz } from '~/bootcamp/slices/bootcamp-quiz.slice'

const BossHealthBar = ({ className }: { className?: string }): React.ReactElement | null => {
  const isQuizStarted = useAppSelector(selectHasStartedQuiz)
  const { t } = useTranslation('bootcampQuiz')
  const health = useAppSelector(selectBossHealth)

  if (!isQuizStarted) return null

  return (
    <div className={`${className} ${health > 0 ? 'opacity-100' : 'opacity-0'} translate duration-700`}>
      <p className="text-white text-md text-center font-semibold mb-1">
        {t('health')}: {Math.round(health)}
      </p>
      <div className="relative flex flex-col justify-center">
        <ProgressBar
          className="relative w-64 md:w-72 z-2 border-2 border-black-jet"
          percentage={health}
          progressClass="from-red-raspberry to-pink-logo"
          size="large"
          style={{ height: 22 }}
        />
      </div>
    </div>
  )
}

export default BossHealthBar
